<template>
  <div class="flex flex-column justify-center align-items-center gap-2">
    <img class="w-64" alt="" src="/svg/moods/mood-3.svg" />
    <h1>Tout s'est bien passé, le prélèvement automatique est en place. Merci !</h1>
    <a class="text-2xl text-blue" href="/">Retour à l'application</a>
  </div>
</template>

<script>
export default { }
</script>